module.exports = __webpack_public_path__ + "static/media/duplicate-public.663a0a30.svg";